/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from "prop-types";
import { jsx } from '@emotion/core';
const Axis = ({
  axisColor,
  axisVisible,
  axisWidth,
  getX,
  getY,
  maxX,
  maxY,
  minX,
  minY,
  unitWidth
}) => {
  // drawn Oxygen coordinate systems for width and height are entered or by default 
  return axisVisible ? jsx("g", {
    className: 'DGN-Axis-BarChart',
    stroke: axisColor,
    strokeWidth: axisWidth
  }, jsx("line", {
    x1: getX(minX),
    y1: getY(minY),
    x2: getX(maxX + unitWidth + 0.5),
    y2: getY(minY)
  }), jsx("line", {
    x1: getX(minX),
    y1: getY(minY),
    x2: getX(minX),
    y2: getY(maxY + 5)
  })) : null;
};
Axis.defaultProps = {
  axisColor: '#7F828E',
  axisOpacity: 1,
  axisVisible: true,
  axisWidth: 0.5,
  getX: x => x,
  getY: quantity => quantity,
  unitWidth: 1
};
Axis.propTypes = {
  /** the axisColor change color */
  axisColor: PropTypes.string,
  /** the axisOpacity property sets the opacity of an element*/
  axisOpacity: PropTypes.number,
  /** the axisVisible Hide or show the Axis axis */
  axisVisible: PropTypes.bool,
  /** the axisWidth change the thickness of the column */
  axisWidth: PropTypes.number,
  /** the getX position x on Ox*/
  getX: PropTypes.func,
  /** the getY position y on Oy */
  getY: PropTypes.func,
  /** the maxX is maximum of Ox quantity returned by data*/
  maxX: PropTypes.number,
  /** the maxY is maximum of Oy quantity returned by data*/
  maxY: PropTypes.number,
  /** the minX is minimum of OX quantity returned by data*/
  minX: PropTypes.number,
  //** the minY is minimum of Oy quantity returned by data*/
  minY: PropTypes.number,
  /** the unitWidth */
  unitWidth: PropTypes.number
};
export default Axis;